import axios, { AxiosInstance, AxiosError } from 'axios';
import { getCurrentSubdomain } from './subdomain';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api';

const apiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('staffAccessToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;

  const subdomain = getCurrentSubdomain();
  if (subdomain) config.headers['X-Estate-Subdomain'] = subdomain;

  return config;
});

apiClient.interceptors.response.use(
  response => response,
  async (error: AxiosError) => {
    const original = error.config as any;
    const isAuthUrl = original.url?.includes('/auth/');

    if (error.response?.status === 401 && !original._retry && !isAuthUrl) {
      original._retry = true;
      try {
        const refreshToken = localStorage.getItem('staffRefreshToken');
        if (!refreshToken) throw new Error('No refresh token');

        const { data } = await axios.post(
          `${API_BASE_URL}/auth/tenant/refresh`,
          { refreshToken },
          { headers: { 'X-Estate-Subdomain': getCurrentSubdomain() ?? '' } }
        );
        localStorage.setItem('staffAccessToken', data.accessToken);
        original.headers.Authorization = `Bearer ${data.accessToken}`;
        return apiClient(original);
      } catch {
        localStorage.removeItem('staffAccessToken');
        localStorage.removeItem('staffRefreshToken');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
